import {paymentStatusTypes} from 'app/constant'
import HistoryItem from 'app/features/orders/componentsv1/shared/orderHistory/HistoryItem'
import OrderHistory from 'app/features/orders/componentsv1/shared/orderHistory/OrderHistory'
import {useSelector} from 'react-redux'
import {RootState} from 'setup'
import {selectViewOrderCreatedBy} from '../../redux/order/orderSlice'
import {
  selectViewOrder,
  selectViewOrderCreatedAt,
  selectViewOrderHistory,
  selectViewOrderNumber,
} from '../../redux/order/orderEditSlice'
import {ViewOrder} from '../../models/OrderState'

export const OrderHistoryWrapper = () => {
  const history = useSelector<RootState, any[]>(selectViewOrderHistory)
  const createdAt = useSelector<RootState, string>(selectViewOrderCreatedAt)
  const orderNumber = useSelector<RootState, string | any>(selectViewOrderNumber)
  const user = useSelector<RootState, string>(selectViewOrderCreatedBy)
  const viewOrder = useSelector<RootState, ViewOrder>(selectViewOrder)

  return (
    <OrderHistory history={history} orderNumber={orderNumber}>
      <HistoryItem
        title='Order Created'
        createdAt={createdAt}
        isLast
        user={user}
        userLabel='Created By'
        orderType={viewOrder.orderType}
      />
    </OrderHistory>
  )
}

export default OrderHistoryWrapper
